export const STATUS_PILL_CONFIG = {
  completed: { type: 'success' },
  canceled: { type: 'default' },
  failed: { type: 'error' },
  in_progress: { type: 'info' },
  scheduled: { type: 'warning' },
  initialized: { type: 'default' },
}
